import { useCallback } from "react";
import api from "../../services/api";

const useLossReasons = () => {
  const list = useCallback(async ({ kanbanBoardId, activeOnly = true }) => {
    if (!kanbanBoardId) return [];
    const { data } = await api.get("/loss-reasons", {
      params: { kanbanBoardId, activeOnly }
    });
    return data?.reasons || [];
  }, []);

  const create = useCallback(async ({ kanbanBoardId, name }) => {
    const { data } = await api.post("/loss-reasons", {
      kanbanBoardId,
      name
    });
    return data;
  }, []);

  const update = useCallback(async (lossReasonId, { kanbanBoardId, name }) => {
    const { data } = await api.put(`/loss-reasons/${lossReasonId}`, {
      kanbanBoardId,
      name
    });
    return data;
  }, []);

  const remove = useCallback(async (lossReasonId, { kanbanBoardId }) => {
    const { data } = await api.delete(`/loss-reasons/${lossReasonId}`, {
      params: { kanbanBoardId }
    });
    return data;
  }, []);

  return { list, create, update, remove };
};

export default useLossReasons;
